import React, { Component } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { ApplicationState } from 'store/rootReducer';
import _ from 'lodash';
import styles from './BzmBackdrop.module.css';
import SimpleLoader from '../loaders/SimpleLoader';

/**
 * Global backdrop with animation.
 */
class BzmBackdrop extends Component<AllProps> {
  state = { isShown: false, hidden: true };

  componentDidUpdate(prevProps: Readonly<AllProps>) {
    if (prevProps.visible != this.props.visible) {
      //Showing
      if (this.props.visible === true) {
        this.setState({ hidden: false }, () => {
          _.delay(() => this.setState({ isShown: true }), 50);
        });
      } else {
        this.setState({ isShown: false }, () => {
          _.delay(() => this.setState({ hidden: true }), 50);
        });
      }
    }
  }

  componentWillUnmount() {
    this.setState({ isShown: false });
  }

  render() {
    if (this.state.hidden) {
      return <></>;
    }

    return (
      <div className="modal-white-backdrop">
        {this.state.isShown && (
          <div
            className="text-center"
            style={{ marginTop: 'calc(50vh - 30px)', width: '100%', position: 'absolute', zIndex: 10000 }}
          >
            <SimpleLoader loaderSize={30} loadingText={this.props.text} style={{ marginBottom: 20 }} />
          </div>
        )}
        <div
          className={clsx('fade text-center modal-backdrop', this.state.isShown ? 'show' : undefined, styles.backDrop)}
        ></div>
      </div>
    );
  }
}

const mapStateToProps = ({ ui }: ApplicationState) => ({
  visible: ui.backdrop.visible,
  text: ui.backdrop.text,
});

type MapStateToProps = ReturnType<typeof mapStateToProps>;
type AllProps = MapStateToProps;

export default connect(mapStateToProps, {})(BzmBackdrop);
